import { useTranslation } from 'react-i18next'

import TagColor from '@/modules/admin-center/utilities/tags/TagColor'
import { Accordion } from '@/modules/shared/components/accordion/Accordion'
import { useGetProductModalProductTags } from '@/modules/shared/components/product-modal/hooks/useGetProductModalProductTags'
import { QueryResult } from '@/modules/shared/components/query-result/QueryResult'

interface ProductModalProductTagsProps {
  tagCount: number
  productId: number
}

export default function ProductModalProductTags({ tagCount, productId }: ProductModalProductTagsProps) {
  const { t } = useTranslation()
  const { fetchProductModalProductTags, tags, loadingStates, error } = useGetProductModalProductTags({
    productId,
  })

  const handleAccordionOpen = () => {
    if (tags.length === 0 && tagCount > 0) {
      fetchProductModalProductTags()
    }
  }

  return (
    <>
      <section className="mt-2">
        <Accordion
          title={t('general.productTags', 'Product Tags')}
          buttonClassName="px-3 h-11 mt-2.5"
          titleClassName="font-bold"
          titleEndIcon={
            <div className="flex size-5 items-center justify-center rounded-md bg-gray-400 text-xs text-white">
              {tagCount}
            </div>
          }
          onOpen={handleAccordionOpen}
        >
          <QueryResult loading={loadingStates.loading} error={error}>
            <p className="my-3 text-sm">
              {t(
                'productModal.tagsDescription',
                'There may be Product Tags added to this product by users at your Organisation.'
              )}
            </p>
            {(tags?.length || 0) >= 1 ? (
              <div className="my-3 flex min-h-40 flex-wrap items-start gap-2 rounded-md border bg-white p-3 shadow">
                {tags?.map((tag) => (
                  <TagColor key={tag.id} tag={tag} />
                ))}
              </div>
            ) : (
              <div className="border p-4 text-center text-gray-500">
                {t('product.productTags.emptyProductTags', 'There are no Product Tags to display.')}
              </div>
            )}
          </QueryResult>
        </Accordion>
      </section>
    </>
  )
}
